import { FinanceRoutesRegexSpa, SearchRoutesRegex, } from '#pplx/frontend/apps/ask/routing/routeRegexes.js';
import { defineRoutes } from '#pplx/frontend/framework/routing/RouteDef.js';
import { defineSitemap } from '#pplx/frontend/framework/routing/sitemap.js';
import { toSpaRoutes } from '#pplx/frontend/framework/routing/toSpaRoutes.js';
export const COMPUTER_UTILITIES_ROUTE_PATTERNS = [
    '/computer/skills/:slug',
    '/computer/skills',
    '/computer/plugins/categories/:categoryKey',
    '/computer/plugins/skills/:skillId',
    '/computer/plugins/connectors/:connectorId',
    '/computer/plugins/:pluginId',
    '/computer/plugins',
    '/computer/workflows',
    '/computer/memory',
    '/computer/connectors',
    '/computer/credentials-vault',
];
export const ComputerUtilitiesRoutesRegex = '^\\/computer\\/(?:skills\\/[^/]+|skills|plugins\\/categories\\/[^/]+|plugins\\/skills\\/[^/]+|plugins\\/connectors\\/[^/]+|plugins\\/[^/]+|plugins|workflows|memory|connectors|credentials-vault)\\/?$';
export const routes = defineRoutes({
    // Regex routes precede overlapping parameterized routes.
    [SearchRoutesRegex]: true,
    // Account routes - grouped by path hierarchy
    // /account/api/* routes
    '/account/api/files/:repositoryUuid': true,
    '/account/api/members': true,
    '/account/api/billing': true,
    '/account/api/files': true,
    '/account/api/limits': true,
    '/account/api/group': true,
    '/account/api/keys': true,
    '/account/api/playground/search': true,
    '/account/api': true,
    // /account/org/* routes
    '/account/org/identity': true,
    '/account/org/data-privacy': true,
    '/account/org/encryption': true,
    '/account/org/permissions': true,
    '/account/org/roles-permissions': true,
    '/account/org/roles-permissions/groups/:groupId': true,
    '/account/org/roles-permissions/:roleId': true,
    '/account/org/apps': true,
    '/account/org/connectors': true,
    '/account/org/credentials-vault': true,
    '/account/org/skills': true,
    '/account/org/plugins': true,
    '/account/org/plugins/skills/:skillId': true,
    '/account/org/plugins/:pluginId': true,
    '/account/org/enterprise-apis': true,
    '/account/org/computer': true,
    '/account/org/comet': true,
    '/account/org/comet-telemetry': true,
    '/account/org/credits-usage': true,
    '/account/org/billing': true,
    '/account/org/credits-usage/:creditLimitId': true,
    '/account/org/analytics': true,
    '/account/org/members': true,
    '/account/org/details': true,
    '/account/org': true,
    // /account/pro-perks/* routes
    '/account/pro-perks/:name': true,
    '/account/pro-perks': true,
    // /account/tasks/* routes
    '/account/tasks/:taskId': true,
    '/account/tasks': true,
    // Other /account/* routes
    '/account/site-instructions': true,
    '/account/preferences': true,
    '/account/personalize/memories': true,
    '/account/personalize': true,
    '/account/memory': true,
    '/account/computer': true,
    '/account/integrations': true,
    '/account/devices': true,
    '/account/notifications': true,
    '/account/analytics': true,
    '/account/usage': true,
    '/account/credits': true,
    '/account/connectors': true,
    '/account/credentials-vault': true,
    '/account/shortcuts': true,
    '/account/details': true,
    '/account': true,
    // Discover routes - most specific first
    '/discover/:topic/:slug': true,
    '/discover/:topic': true,
    '/discover': true,
    // Spaces routes - most specific first
    '/spaces/:slug/:threadSlug': true,
    '/projects/:slug/:threadSlug': true,
    '/spaces/:slug': true,
    '/projects/:slug': true,
    '/teammate/:uuid': true,
    '/spaces': true,
    '/projects': true,
    // Other parameterized routes
    '/page/:slug': true,
    // Notes routes
    // Composer SDK route
    '/composer-sdk': true,
    // Health routes
    '/health': true,
    '/account/health': true,
    '/onboarding-neo': true,
    // Security routes - most specific first
    '/security/sources/:source_id': true,
    '/security': true,
    // Teammate session permalink route
    '/session/:slug': true,
    // Computer routes - most specific first
    '/computer/new': true,
    '/computer/t/:slug': true,
    '/computer/tasks/:slug': true,
    '/computer/tasks': true,
    '/computer/automations/:automationId/runs/:runId': true,
    '/computer/automations/:automationId': true,
    '/computer/automations': true,
    '/computer/landing/:slug': true,
    '/computer/landing': true,
    '/computer/gallery/:slug': true,
    '/computer/gallery': true,
    '/computer/live/:slug?': true,
    '/computer/artifacts': true,
    '/computer/skills/:slug': true,
    '/computer/skills': true,
    '/computer/plugins/categories/:categoryKey': true,
    '/computer/plugins/skills/:skillId': true,
    '/computer/plugins/connectors/:connectorId': true,
    '/computer/plugins/:pluginId': true,
    '/computer/plugins': true,
    '/computer/workflows': true,
    '/computer/memory': true,
    '/computer/connectors': true,
    '/computer/credentials-vault': true,
    '/computer/a/:slug': true,
    '/computer': true,
    // B routes
    '/b/home': true,
    '/b/zen': true,
    '/b/cloud-picker': true,
    '/chrome/new-tab': true,
    // Static routes
    '/perplexify_me': true,
    '/academic': true,
    '/library': true,
    '/patents': true,
    // Prototype routes
    [FinanceRoutesRegexSpa]: true,
    '/cfo/:tab?': true,
    // Blank route mainly for testing/benchmarking purposes
    '/__blank__': true,
    '/__internal__/wizard': true,
    '/__internal__/workflow/teammate': true,
    '/__internal__/workflow/agents': true,
    '/__internal__/workflow/assets': true,
    '/__internal__/workflow/widgets': true,
    '/__internal__/workflow/icons': true,
    '/__internal__/workflow': true,
    '/': true,
});
/** @internal */
export const sitemap = defineSitemap(routes, {
    [SearchRoutesRegex]: false,
    // Account routes - grouped by path hierarchy
    // /account/api/* routes
    '/account/api/files/:repositoryUuid': false,
    '/account/api/members': false,
    '/account/api/billing': false,
    '/account/api/files': false,
    '/account/api/limits': false,
    '/account/api/group': false,
    '/account/api/keys': false,
    '/account/api/playground/search': false,
    '/account/api': false,
    // /account/org/* routes
    '/account/org/identity': false,
    '/account/org/data-privacy': false,
    '/account/org/encryption': false,
    '/account/org/permissions': false,
    '/account/org/roles-permissions': false,
    '/account/org/roles-permissions/groups/:groupId': false,
    '/account/org/roles-permissions/:roleId': false,
    '/account/org/apps': false,
    '/account/org/connectors': false,
    '/account/org/credentials-vault': false,
    '/account/org/skills': false,
    '/account/org/plugins': false,
    '/account/org/plugins/skills/:skillId': false,
    '/account/org/plugins/:pluginId': false,
    '/account/org/enterprise-apis': false,
    '/account/org/computer': false,
    '/account/org/comet': false,
    '/account/org/comet-telemetry': false,
    '/account/org/credits-usage': false,
    '/account/org/billing': false,
    '/account/org/credits-usage/:creditLimitId': false,
    '/account/org/analytics': false,
    '/account/org/members': false,
    '/account/org/details': false,
    '/account/org': false,
    // /account/pro-perks/* routes
    '/account/pro-perks/:name': false,
    '/account/pro-perks': false,
    // /account/tasks/* routes
    '/account/tasks/:taskId': false,
    '/account/tasks': false,
    // Other /account/* routes
    '/account/site-instructions': false,
    '/account/preferences': false,
    '/account/personalize/memories': false,
    '/account/personalize': false,
    '/account/memory': false,
    '/account/computer': false,
    '/account/integrations': false,
    '/account/devices': false,
    '/account/notifications': false,
    '/account/analytics': false,
    '/account/usage': false,
    '/account/credits': false,
    '/account/connectors': false,
    '/account/credentials-vault': false,
    '/account/shortcuts': false,
    '/account/details': false,
    '/account': false,
    // Discover routes - most specific first
    '/discover/:topic/:slug': false,
    '/discover/:topic': false,
    '/discover': false,
    // Spaces routes - most specific first
    '/spaces/:slug/:threadSlug': false,
    '/projects/:slug/:threadSlug': false,
    '/spaces/:slug': false,
    '/projects/:slug': false,
    '/teammate/:uuid': false,
    '/spaces': false,
    '/projects': false,
    // Other parameterized routes
    '/page/:slug': false,
    // Notes routes
    // Composer SDK route
    '/composer-sdk': false,
    // Health routes
    '/health': false,
    '/account/health': false,
    '/onboarding-neo': false,
    // Security routes - most specific first
    '/security/sources/:source_id': false,
    '/security': false,
    // Teammate session permalink route
    '/session/:slug': false,
    // Computer routes - most specific first
    '/computer/new': false,
    '/computer/t/:slug': false,
    '/computer/tasks/:slug': false,
    '/computer/tasks': false,
    '/computer/automations/:automationId/runs/:runId': false,
    '/computer/automations/:automationId': false,
    '/computer/automations': false,
    '/computer/landing/:slug': false,
    '/computer/landing': false,
    '/computer/gallery/:slug': false,
    '/computer/gallery': false,
    '/computer/live/:slug?': false,
    '/computer/artifacts': false,
    '/computer/skills/:slug': false,
    '/computer/skills': false,
    '/computer/plugins/categories/:categoryKey': false,
    '/computer/plugins/skills/:skillId': false,
    '/computer/plugins/connectors/:connectorId': false,
    '/computer/plugins/:pluginId': false,
    '/computer/plugins': false,
    '/computer/workflows': false,
    '/computer/memory': false,
    '/computer/connectors': false,
    '/computer/credentials-vault': false,
    '/computer/a/:slug': false,
    '/computer': false,
    // B routes
    '/b/home': false,
    '/b/zen': false,
    '/b/cloud-picker': false,
    '/chrome/new-tab': false,
    // Static routes
    '/perplexify_me': false,
    '/academic': { changefreq: 'daily', priority: 1 },
    '/library': false,
    '/patents': false,
    // Prototype routes
    [FinanceRoutesRegexSpa]: { path: '/finance', changefreq: 'daily', priority: 1 },
    '/cfo/:tab?': false,
    // Blank route mainly for testing/benchmarking purposes
    '/__blank__': false,
    '/__internal__/wizard': false,
    '/__internal__/workflow/teammate': false,
    '/__internal__/workflow/agents': false,
    '/__internal__/workflow/assets': false,
    '/__internal__/workflow/widgets': false,
    '/__internal__/workflow/icons': false,
    '/__internal__/workflow': false,
    '/': false,
});
// Consumed by Bazel route manifest AST extraction, not runtime imports.
void sitemap;
export const SPA_ROUTES = toSpaRoutes(routes);
//# sourceMappingURL=spaRoutes.js.map